import { useQuery } from "react-query";
import axios from "../axios";

const useGetItemsToReturn = ({ seller_id }) => {
  const query = useQuery("items-to-be-returned", async () => {
    try {
      return await axios.get(
        `/api/v2/product/returned?id=${seller_id}&page=1&limit=20`
      );
    } catch (error) {
      console.log(error);
    }
  });

  return query;
};

export default useGetItemsToReturn;
